// extracted by mini-css-extract-plugin
module.exports = {"app":"FullPageLayout_app__YlrPA"};